<template>
    <div class="login-popup text_11">
        <div class="login-popup__header flex-c" v-if="!$auth.loggedIn">
            <nuxt-link to="/lk/register" @click.native="$emit('close')">{{ $t("lk_register") }}</nuxt-link>
            <nuxt-link to="/lk/login" class="flex-c" @click.native="$emit('close')"
                >{{ $t("lk_auth") }} <svg-icon name="arrow-right--thin" width="16" height="16" v-if="!$device.isMobile"
            /></nuxt-link>
        </div>
        <div class="login-popup__header flex-c" v-if="$auth.loggedIn && $device.isMobile">
            <span class="like-link" @click="logout()">{{ $t("logout") }}</span>
        </div>
        <div class="login-popup__links">
            <LkLinks @close="$emit('close')"></LkLinks>
        </div>
        <div class="login-popup__footer flex-c" v-if="$auth.loggedIn && !$device.isMobile">
            <span class="like-link" @click="logout()">{{ $t("logout") }}</span>
        </div>
    </div>
</template>
<script>
import LkLinks from "@/components/LkLinks";
export default {
    name: "LoginPopup",
    components: { LkLinks },
    methods: {
        async logout() {
            await this.$auth.logout();
            this.$nuxt.$emit("hide-user-popup");
            sessionStorage.removeItem("storedOrderData");
            // window.location.reload();
        },
    },
};
</script>
<style lang="less">
.login-popup {
    position: absolute;
    top: 100%;
    left: 0;
    width: 240px;
    background: @bg;
    border: 1px solid @border2;
    z-index: 1;
    @media @sm {
        position: fixed;
        z-index: 10;
        top: 50%;
        left: 50%;
        border: 0;
        transform: translate(-50%, -50%);
    }
    a {
        line-height: 15px;
    }
    &__header,
    &__footer {
        padding: 9px 16px;
        border-bottom: 1px solid @border2;
        justify-content: space-between;
        @media @sm {
            justify-content: flex-start;
            padding: 40px 40px 24px;
            a + a {
                &:before {
                    content: "/";
                    margin: 0 8px;
                    color: @text_3;
                }
            }
        }
        svg {
            margin-left: 8px;
        }
    }
    &__footer {
        border-top: 1px solid @border2;
        border-bottom: 0;
        padding: 16px;
        @media @sm {
            padding: 24px 40px 40px 40px;
        }
    }
    &__links {
        padding: 16px;
        @media @sm {
            padding: 24px 40px 40px;
        }
        a {
            display: block;
            @media @sm {
                padding: 8px 0;
            }
            + a {
                margin-top: 12px;
                @media @sm {
                    margin-top: 0;
                }
            }
        }
    }
}
</style>
